import React from "react";
import {
  Col,
  ModalBody,
  Row,
} from "reactstrap";

import Linkify from 'react-linkify';
import { Button, QRCardModal } from "components";
import { connect } from 'react-redux';
import { config } from "_constants";
import { notificationMessageActions } from "_actions"

class ShareEventModal extends React.Component {
  constructor(props) {
    super(props);
    const { eventId } = props.props;
    console.log("CreateUpdateLocation constructor()", props)
    this.state = {
      eventId: eventId,
    };

    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  componentDidMount() {

  }



  copyToClipboard = (e) => {
    this.textArea.select();
    document.execCommand('copy');
    e.target.focus();
    this.props.dispatch(notificationMessageActions.addNotificationToQueue("Link Copied", 3))

  }

  copyToClipboard2 = (e) => {
    this.textArea2.select();
    document.execCommand('copy');
    e.target.focus();
    this.props.dispatch(notificationMessageActions.addNotificationToQueue("Short Link Copied", 3))

  }


  render() {
    const { eventId } = this.state
    const { is_xs } = this.props

    console.log("fees", eventId)
    // let remit = num * ticket.price
    // let lvFee = remit * (liveNyteTicketPercentage/100) +
    //             num   * liveNyteTicketFlatFee
    // let stripeFee = (remit + lvFee + stripeFlatFee) / (1 - (stripePercentage/100)) - remit - lvFee
    // console.log("num", num, "remit", remit, "lvFee", lvFee, "stripeFee", stripeFee)

    return (
      <ModalBody className="pt-1 text-left">
        <Row>
          <Col xs={12} className="text-left">
            <h6 className="surtitle my-2">Link </h6>
          </Col>
          <Col xs={7} className="text-left mt-2" >
            <a target="_blank" rel="noopener noreferrer" href={`${config.serverUrl}/e/${eventId}`}>
              {`${config.serverUrl.substring(config.serverUrl.indexOf("/") + 2)}/e/${eventId}`}
              <form style={{ visiblity: "hidden", height: "0px" }}>
                <textarea style={{ opacity: "0", width: "1px" }} ref={(textarea) => this.textArea = textarea}
                  defaultValue={`${config.serverUrl.substring(config.serverUrl.indexOf("/") + 2)}/e/${eventId}`}>
                </textarea>
              </form>
            </a>
          </Col>
          <Col xs={5} className="text-right mt-2">
            {document.queryCommandSupported('copy') &&
              <Button onClick={e => this.copyToClipboard(e)} size={"sm"} color={"primary"} className="">
                Copy Link
              </Button>
            }
          </Col>
          <Col xs={7} className="text-left mt-3">
            <a href={`https://${config.shortEventLink}/${eventId}`} target="_blank" rel="noopener noreferrer">
              {`${config.shortEventLink}/${eventId}`}
              <form style={{ visiblity: "hidden", height: "0px" }}>
                <textarea style={{ opacity: "0", width: "1px" }} ref={(textarea2) => this.textArea2 = textarea2}
                  defaultValue={`${config.shortEventLink}/${eventId}`}>
                </textarea>
              </form>
            </a>
          </Col>
          <Col xs={5} className="text-right mt-3">
            {document.queryCommandSupported('copy') &&
              <Button onClick={e => this.copyToClipboard2(e)} size={"sm"} color={"primary"} className="">
                Copy Short Link
              </Button>
            }
          </Col>
          <Col xs={12} className="mt-3">
            <QRCardModal url={`${config.serverUrl}/e/${eventId}`} />
          </Col>
        </Row>
      </ModalBody >
    );
  }
}

function mapStateToProps(state) {
  const { screenSizeData } = state;
  const { is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest } = screenSizeData;

  return {
    is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest

  };
}

const connectedShareEventModal = connect(mapStateToProps)(ShareEventModal);
export { connectedShareEventModal as ShareEventModal }; 